module.exports = __webpack_public_path__ + "img/bg-dashboard.20b7a03c.png";